<h2>Error de loja - {{ form.get('code')?.value }}</h2>
<form [formGroup]="form" class="form-b4a shopping-error-form">
  <span class="p-float-label">
    <input id="code" formControlName="code" pInputText readonly />
    <label for="code">Código do erro</label>
  </span>
  <span class="p-float-label">
    <input id="title" formControlName="title" pInputText />
    <label for="title">Título</label>
  </span>
  <span class="p-float-label">
    <p-dropdown
      [options]="iconOptions"
      formControlName="icon"
      optionLabel="label"
      [showClear]="false"
      placeholder="Selecione um ícone"
    >
      <ng-template let-selected pTemplate="selectedItem">
        <div class="icon-dropdown-item" *ngIf="selected">
          <img
            [src]="selected.value"
            alt="icon"
            style="width: 18px; height: 18px"
          />
          <span>{{ selected.label }}</span>
        </div>
        <span *ngIf="!selected">Selecione um ícone</span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="icon-dropdown-item">
          <img
            [src]="option.value"
            alt="icon"
            style="width: 18px; height: 18px"
          />
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
    </p-dropdown>
    <label for="icon">Ícone do modal</label>
  </span>

  <span class="p-float-label">
    <input id="buttonText" formControlName="buttonText" pInputText />
    <label for="buttonText">Texto do botão</label>
  </span>
  <span class="p-float-label full-w">
    <textarea
      id="message"
      formControlName="message"
      pInputTextarea
      rows="3"
    ></textarea>
    <label for="message">Mensagem</label>
  </span>
  <span class="p-float-label full-w">
    <textarea
      id="description"
      formControlName="description"
      pInputTextarea
      rows="3"
    ></textarea>
    <label for="description">Descrição</label>
  </span>

  <div class="buttons">
    <p-button
      label="Salvar"
      type="submit"
      [disabled]="!form.valid"
      (click)="updateError()"
    ></p-button>
  </div>
</form>
